import { render, staticRenderFns } from "./modal-folder-delete-confirmation.vue?vue&type=template&id=4824db58&"
import script from "./modal-folder-delete-confirmation.vue?vue&type=script&lang=js&"
export * from "./modal-folder-delete-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./modal-folder-delete-confirmation.vue?vue&type=style&index=0&id=4824db58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports